<template>
  <div class="box">
    <div class="boxData">
      <el-backtop :right="40" :bottom="150" id="backTopBtn" class="box_1"/>
      <div class="boxData_1">
        <div class="info" v-for="item in dataList" :key="item.id">
          <img :src="item.svg"  class="svg">
          <h2 class="h2_1" >{{ item.name }}</h2>
          <p v-for="er in item.child" :key="er.id" @click="childBtn(item, er.id)">{{ er.title }}</p>
        </div>
      </div>
      <div class="boxData_2">
        <div class="text">
          <p>盛泰光電科技株式会社&nbsp;&nbsp;江西盛泰精密光学株式会社&nbsp;&nbsp;深セン盛泰光電科技株式会社</p>
          <P>Add: 重慶市大足区通橋街道西湖大道13号&nbsp;&nbsp;江西省新余市分宜県城東盛泰工業園&nbsp;&nbsp;深セン市竜華区華栄路連建産業パーク1棟D号館15階</P>
          <p>電話番号:023-85226001 023-85226002 </p>
          <p>ファックス番号:023-85226001 023-85226002 </p>
        </div>
        <div class="image">
          <h3>公式Wechatへ<br />公式情報をさらに</h3>
            <div id="qrcode_1" ref="qrcode_1" class="qrcode_1" ></div>
        </div>
      </div>
      <p class="p1">© {{new Date().getFullYear()}} Shine Optics Technology Company Limited 
        <!-- <a target="_blank" href="https://beian.miit.gov.cn/#/Integrated/index">渝ICP备2022000344号-1</a> -->
        </p>
    </div>
  </div>
</template>

<script>
import { reactive, toRefs, ref, onMounted ,watch,toRaw} from "vue";
import { useRouter,useRoute } from "vue-router";
import QRCode from 'qrcodejs2'
export default {
  emits: ['submitData'],

  setup(props, { emit }) {
    const route = useRouter();
    const r = useRoute()
   watch(() => route.currentRoute.value.path, (count, prevCount) => {
    // console.log(count);
      if(count=='/ja/product'){
        localStorage.setItem('menuId',1)
      }else if(count=='/ja/about' || count == '/ja/manufacture'||count=='/ja/aboutId'||count=='/ja/aboutImg' ||count=='/ja/quality'||count == '/ja/research' ){
         localStorage.setItem('menuId',2)
      }else if(count=='/ja/news'||count=='/ja/news'){
         localStorage.setItem('menuId',3)
      }else if(count == '/ja/cooperation' || count == '/ja/business_partner'|| count == '/ja/commercial_ethics'|| count == '/ja/social_responsibility'|| count == '/ja/develop'){
        localStorage.setItem('menuId',4)
      }else if(count == '/ja/join' || count=='/ja/joinId' || count=='/ja/idea'){
         localStorage.setItem('menuId',5)
      }else if(count =='/ja/contactus'){
        localStorage.setItem('menuId',6)
      }
    },{ immediate: true })
    const state = reactive({
      dataList: [
        { id: 1, svg: require('@/assets/foot/产品中心.svg'), name: '製品情報', child: [{ id: 5, title: 'モバイル端末' }, { id: 4, title: 'ノートパソコン製品' }, { id: 3, title: 'アイオット' }, { id: 2, title: '車載と医療製品' },{id:1,title:"LED"}] },
        { id: 5, svg: require('@/assets/foot/加入盛泰.svg'), name: '採用情報', child: [{ id: 1, title: '求人情報' }, { id: 2, title: '人事理念' }] },
        { id: 3, svg: require('@/assets/foot/新闻活动.svg'), name: 'ニュースリリース', child: [{ id: 1, title: 'ニュース' }, { id: 2, title: 'イベント' }] },
        { id: 2, svg: require('@/assets/foot/盛泰制造.svg'), name: '事業案内', child: [{ id: 1, title: '技術開発' }, { id: 2, title: '品質保証' }, { id: 3, title: '生産環境' }] },
      ]
    })
    let methods = {
            qrCode() {
        let qrcode_1 = new QRCode('qrcode_1', {
          width: 100,
          height: 100,
          text: 'https://www.shine-optics.com/ja', // 二维码地址
          colorDark: "#000",
          colorLight: "#fff",
        })
            },
      childBtn(item, id) {
        // console.log(item);
        localStorage.setItem('menuId', item.id)
        document.getElementById('backTopBtn').click()
        switch (item.id) {
          case 1:
            route.push('/ja/product')
            localStorage.setItem('id', id)
            emit('submitData', id)
            break;
          case 2:
            // console.log(item);
            if(id==3){
                  localStorage.setItem('emp_id', 1)
                  route.push({ path: '/ja/manufacture' })

            }else if(id==2){
                  route.push('/ja/quality')

            }else if(id==1){
              route.push('/ja/research')

            }
            break;
          case 3:
            route.push("/ja/news");
            break;
          case 5:
            if(id == 1){
                route.push('/ja/joinId')
            }else if(id==2){
              route.push('/ja/idea')
            }
            break;

          default:
        }
        // window.scrollTo(0, 0);

      }
    }
    onMounted(() => {
      let svg = document.getElementsByClassName('svg')
      for (let i = 0; i < svg.length; i++) {
        if(i==2){
          svg[i].style.left  = '30px'
        }
        
      }
      // console.log('route',route.currentRoute._rawValue.path);
      methods.qrCode()
    })
    return {
      ...toRefs(state),
      ...methods
    };
  },
};
</script>

<style scoped lang="less">
.h2_1{
  font-size:18px;
}
.p1 {
  text-align: center;
  color: black;
  font-size: 14px;
  min-height: 30px;
  height: auto;
  line-height: 30px;
  background-color: #E6E6E6;
  
  margin: 0;
  padding: 0;

  a {
    cursor: pointer;
    color: black;
    text-decoration: none;
  }
}

.box {
  margin-top: 50px;
  width: 100%;
  min-height: 500px;
  background-color: #E6E6E6;
  overflow: hidden;

  .boxData {
    height: 100%;
    width: 80%;
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    max-width: 1920px;

    .boxData_1,
    .boxData_2 {
      flex: 1;
    }

    .boxData_1 {
      display: flex;
    }

    .boxData_2 {
      display: flex;
      .text {
        border-top: 1px solid black;
        flex: 3;
        color: black;
        padding: 30px 32px 0 50px;
        box-sizing: border-box;
      }

      .image {
        text-align: center;
        flex: 1;
        margin-left: 50px;
       
      }
    }
  }
}

.info {
  width: 100%;
  position: relative;
  text-align: center;
  min-width: 270px;

  h2 {

    margin-top: 40px;
    flex-wrap: wrap;
    margin-left: -22px;
  }

  p {
    margin-left: -30px;
    font-weight: 400;
    cursor: pointer;
    // transition: all 0.3s;
  }

  p:hover {
    color: red;
  }

  img {
    position: absolute;
    top: 35px;
    left: 90px;
    width: 40px;
    height: 40px;
  }
}
.qrcode_1{
  margin-left: 50%;
  transform: translateX(-25%);
}

</style>